export const preferencesPageInnerClassName =
  "mx-auto flex w-full flex-col gap-8 lg:max-w-5xl lg:gap-8";
export const preferencesCardClassName =
  "overflow-hidden rounded-none border-0 p-0 lg:rounded-lg lg:border lg:border-gray-200";
export const preferencesCardHeaderClassName =
  "border-b border-gray-200 px-4 py-5 lg:px-10";
export const preferencesCardBodyClassName = "flex flex-col gap-6 px-4 py-8 lg:px-10";
